<script>
import VueTypes from 'vue-types'
import { BEHAVIORS } from './utils'

export default {
    name: 'WFieldBehavior',
    props: {
        fields: VueTypes.any,
        field: VueTypes.any.isRequired,
        default: VueTypes.any,
        behaviors: VueTypes.any,
    },
    data () {
        return {
            show: true,
            disabled: false,
            readonly: false,
        }
    },
    watch: {
        fields: {
            handler (fields) {
                if (!this.behaviors) return
                this.manager(this.behaviors)
            },
            immediate: true,
        },
    },
    methods: {
        manager (behaviors) {
            Object.keys(behaviors).forEach((key) => {
                if (!this[key]) return console.warn(`The ${key} is not a behavior`)

                const behavior = behaviors[key]
                const rules = Array.isArray(behavior.when) ? behavior.when : [behavior.when]
                return this[key](rules)
            })
        },
        // TODO: Added more conditions
        check (rules) {
            return !!rules.map(({ key, eq }) => this.fields[key] === eq).filter(Boolean).length
        },
        [BEHAVIORS.RESET] (rules) {
            if (this.check(rules) && this.fields[this.field] !== this.default) this.$emit('reset', this.default)
        },
        [BEHAVIORS.SHOW] (rules) {
            this.show = this.check(rules)
        },
        [BEHAVIORS.DISABLED] (rules) {
            this.disabled = this.check(rules)
        },
        [BEHAVIORS.READONLY] (rules) {
            this.readonly = this.check(rules)
        },
    },
    render (h) {
        const {
            show, disabled, readonly,
        } = this

        return h(
            'div', [
                show && this.$scopedSlots.default({
                    disabled,
                    readonly,
                }),
            ],
        )
    },
}
</script>
